import React from 'react'
import { Router } from 'components'
import './App.scss'

const App = () => {
  return <Router />
}

export default App
